var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CFBDFC62-450A-425B-AF65-F239AD622C2C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mob-app-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Negative-emotion_change-emotion",
    transform: "translate(-49.000000, -727.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Segmented-Controller---4-Segments-Copy",
    transform: "translate(0.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(24.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "negative-emotion-copy",
    transform: "translate(0.000000, 432.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sad-face",
    transform: "translate(16.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sad_face",
    transform: "translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C6.71572875,0 0,6.71572875 0,15 C0,23.2842712 6.71572875,30 15,30 C23.2842712,30 30,23.2842712 30,15 C29.9906315,6.71961243 23.2803876,0.00936852177 15,0 Z",
    id: "Path",
    fill: "#8557AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,10.0000002 C6.55056934,10.0003074 6.15614388,9.70074894 6.03582041,9.26772438 C5.91549695,8.83469981 6.09883773,8.37459887 6.484,8.143 L11.484,5.143 C11.956347,4.87063638 12.559816,5.02686379 12.8406637,5.49421612 C13.1215113,5.96156845 12.9762053,6.56775985 12.514,6.857 L7.514,9.857 C7.35889938,9.95061605 7.18116336,10.000064 7,10.0000002 L7,10.0000002 Z",
    id: "Path",
    fill: "#F6ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,12 C13,13.1045695 12.1045695,14 11,14 C9.8954305,14 9,13.1045695 9,12 C9,10.8954305 9.8954305,10 11,10 C12.1045695,10 13,10.8954305 13,12 Z",
    id: "Path",
    fill: "#F6ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.041,22.662 C20.8654807,22.8610004 20.6180666,22.9820835 20.353235,22.9985886 C20.0884034,23.0150937 19.8278697,22.9256673 19.629,22.75 C16.9835869,20.4179185 13.0164131,20.4179185 10.371,22.75 C9.95678644,23.1156125 9.3246125,23.0762136 8.959,22.662 C8.5933875,22.2477864 8.63278644,21.6156125 9.047,21.25 C12.4486992,18.24993 17.5513008,18.24993 20.953,21.25 C21.1520004,21.4255193 21.2730835,21.6729334 21.2895886,21.937765 C21.3060937,22.2025966 21.2166673,22.4631303 21.041,22.662 L21.041,22.662 Z",
    id: "Path",
    fill: "#F6ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,12 C17,10.8954305 17.8954305,10 19,10 C20.1045695,10 21,10.8954305 21,12 C21,13.1045695 20.1045695,14 19,14 C17.8954305,14 17,13.1045695 17,12 Z",
    id: "Path",
    fill: "#F6ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.857,9.515 C23.5725154,9.98822971 22.9583224,10.1413303 22.485,9.857 L17.485,6.857 C17.1717721,6.67638728 16.9804363,6.340758 16.9845236,5.97921216 C16.9887436,5.61766631 17.1877396,5.28652137 17.5050342,5.11315242 C17.8223288,4.93978346 18.2084974,4.95119593 18.515,5.143 L23.515,8.143 C23.9882297,8.42748459 24.1413303,9.04167757 23.857,9.515 L23.857,9.515 Z",
    id: "Path",
    fill: "#F6ECFF"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default __webpack_public_path__ + "static/media/sad-face.8397bd308883c1c45a2b8d87c9c7acf8.svg";
export { ForwardRef as ReactComponent };